import type { Instructor } from '@features/instructors/api/types/instructor.types';

import { useInstructorsData } from '@features/instructors/contexts/data/useInstructorsData';
import * as React from 'react';

import type {
  UseInstructorDetailPanelParams,
  UseInstructorDetailPanelReturn,
} from './useInstructorDetailPanel.types';

export function useInstructorDetailPanel({
  instructorId,
}: UseInstructorDetailPanelParams): UseInstructorDetailPanelReturn {
  const { instructors } = useInstructorsData();
  const { isLoading, isError } = instructors;
  const { data } = instructors;

  const instructor = React.useMemo(
    (): Instructor | undefined =>
      data.elements.find(i => i.instructorId === instructorId),
    [data.elements, instructorId]
  );

  return { instructor, isLoading, isError };
}
